import { Box } from '@mantine/core';
import { IconPointFilled as ResearchPerfEvalIcon } from '@tabler/icons-react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Outlet, createFileRoute } from '@tanstack/react-router';

import { OpenResearchPerfEvalBox } from '@/module/ResearchPerfEval/components/OpenResearchPerfEvalBox';
import { getResearchPerfEvalsOptions } from '@/module/ResearchPerfEval/model/ResearchPerfEvalQuery';

import { NoContentPlaceholder } from '@/core/components';
import { ContextSidebar } from '@/core/components/RootLayout/Sidebar/ContextSidebar';

import { useCurrentUser } from '@feature/security';

export const Route = createFileRoute('/_auth/research-perf-eval/_layout')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'sidebar.researchPerfEval' },
  },
  loader: async ({ context: { queryClient } }) => {
    return await queryClient.ensureQueryData(getResearchPerfEvalsOptions());
  },
});

function RouteComponent() {
  const { data } = useSuspenseQuery(getResearchPerfEvalsOptions());
  const { currentRole } = useCurrentUser();
  const currentResearchPerfEvalYear = new Date().getFullYear() - 1;

  const currentResearchPerfEvalOpen = data.filter(ev => ev.endYear === currentResearchPerfEvalYear).length > 0;

  const tabs = data.map(evaluation => ({
    label: `Evaluarea activităţii de cercetare ${evaluation.startYear} - ${evaluation.endYear}`,
    to: `/research-perf-eval/${evaluation.id}`,
    icon: ResearchPerfEvalIcon,
  }));

  return (
    <Box p="md">
      {!currentResearchPerfEvalOpen && currentRole === 'UNIVERSITY_ADMIN' && (
        <Box mb="15px">
          <OpenResearchPerfEvalBox year={currentResearchPerfEvalYear} />
        </Box>
      )}
      {data?.length > 0 && (
        <>
          <ContextSidebar
            baseUrl=""
            items={tabs}
          />
          <Outlet />
        </>
      )}
      {data?.length === 0 && <NoContentPlaceholder title="Nu a fost deschis pentru raportare nici un raport" />}
    </Box>
  );
}
